import { render } from "./PublicResetPassword.vue?vue&type=template&id=1c95c947&scoped=true"
import script from "./PublicResetPassword.vue?vue&type=script&lang=js"
export * from "./PublicResetPassword.vue?vue&type=script&lang=js"

import "./PublicResetPassword.vue?vue&type=style&index=0&id=1c95c947&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c95c947"]])

export default __exports__